module.exports = __webpack_public_path__ + "img/156.f63f15b8.jpg";